export interface PasswordStrength {
  score: number
  label: 'weak' | 'fair' | 'good' | 'strong'
  color: string
}

export function getPasswordStrength(password: string): PasswordStrength {
  let score = 0
  if (password.length >= 8) score++
  if (/[A-Z]/.test(password)) score++
  if (/[a-z]/.test(password)) score++
  if (/[0-9]/.test(password)) score++
  if (/[^A-Za-z0-9]/.test(password)) score++

  const map: Record<number, PasswordStrength> = {
    0: { score, label: 'weak', color: 'bg-rose-500' },
    1: { score, label: 'weak', color: 'bg-rose-500' },
    2: { score, label: 'fair', color: 'bg-amber-500' },
    3: { score, label: 'good', color: 'bg-yellow-500' },
    4: { score, label: 'strong', color: 'bg-emerald-500' },
    5: { score, label: 'strong', color: 'bg-emerald-500' },
  }

  return map[score]
}
